import Component from './Component';
import GetHandleTitleClick from './GetHandleTitleClick';
export default { Component, GetHandleTitleClick };
